import { io } from 'socket.io-client';
import { SOCKET_BASE_URL } from '../config/api.js';

const readToken = () => {
  try {
    const profile = JSON.parse(localStorage.getItem('profile') || 'null');
    return profile?.token || '';
  } catch {
    return '';
  }
};

let marketSocket = null;

export const connectKvarxMarketSocket = () => {
  const token = readToken();
  if (marketSocket) {
    if (token) marketSocket.auth = { token };
    if (!marketSocket.connected) marketSocket.connect();
    return marketSocket;
  }

  const socket = io(`${SOCKET_BASE_URL}/kvarx`, {
    transports: ['websocket', 'polling'],
    autoConnect: true,
    reconnection: true,
    auth: { token },
  });

  const join = () => {
    socket.emit('kvarx_join', { role: 'company' });
  };

  socket.on('connect', join);
  socket.on('reconnect', join);

  marketSocket = socket;
  return socket;
};
